import type { Label } from '@seen/core/models/label'
import { useMemo } from 'react'
import type { FilterOption } from '#src/components/filter/Filter.tsx'
import { LabelColor } from '#src/components/LabelColor.tsx'
import { LabelOption } from '#src/components/LabelOption.tsx'

export function useLabelFilterOptions(
  labels: Label[] | undefined
): FilterOption[] {
  return useMemo(
    () =>
      (labels ?? []).map((l) => ({
        label: <LabelOption color={l.color} label={l.name} />,
        value: l.referenceString,
        icon: <LabelColor color={l.color} />,
        keywords: [l.name],
      })),
    [labels]
  )
}
